var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.method)?_c('div',[_vm._t("default",null,{"method":_vm.method})],2):(_vm.empty && _vm.isEmpty)?_c('div',[_vm._t("empty")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }